import { AuthService } from './../../services/AuthService';
import './MessageBox.css';
import Cookie from 'js-cookie';
import { BrowserRouter, Route } from 'react-router-dom';
import BlueActionBtn from './../Buttons/BlueActionBtn';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setLogOut } from '../../pages/Store/actions/storeService';
import React, { Component } from 'react';

class MessageBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: props.message,
      signout: props.signout,
      onClose: props.onClose,
    };
  }

  handleSignout = (event) => {
    this.props.setLogOut("logout")
    // localStorage.removeItem('Login');
    // document.cookie.split(';').forEach(function (c) {
    //   document.cookie = c
    //     .replace(/^ +/, '')
    //     .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    // });
    // (function () {
    //   document.cookie.split(';').forEach(function (c) {
    //     document.cookie = c
    //       .replace(/^ +/, '')
    //       .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    //   });
    // })();
    // document.cookie =
    //   'my_cookie=; path=/; domain=idpdecathlon.oxylane.com; expires=' +
    //   new Date(0).toUTCString();

    // window.localStorage.clear();
    // Cookie.remove('PF');
    // Cookie.remove('currentUser');
    // Cookie.remove('stores');
    // Cookie.remove('storesAll');
    // Cookie.remove('warehouses');

    // localStorage.clear();
    // sessionStorage.clear();
    // AuthService.logout();
    // var cookies = document.cookie.split(';');

    // for (var i = 0; i < cookies.length; i++) {
    //   var cookie = cookies[i];
    //   var eqPos = cookie.indexOf('=');
    //   var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    //   document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
    // }
    // (function () {
    //   var cookies = document.cookie.split('; ');
    //   console.log(cookies);
    //   for (var c = 0; c < cookies.length; c++) {
    //     var d = window.location.hostname.split('.');
    //     while (d.length > 0) {
    //       var cookieBase =
    //         encodeURIComponent(cookies[c].split(';')[0].split('=')[0]) +
    //         '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' +
    //         d.join('.') +
    //         ' ;path=';

    //       var p = window.location.pathname.split('/');
    //       document.cookie = cookieBase + '/';
    //       while (p.length > 0) {
    //         document.cookie = cookieBase + p.join('/');
    //         p.pop();
    //       }
    //       d.shift();
    //     }
    //   }
    // })();
    // setTimeout(() => {
    //   return (window.location = '/');
    // }, 1000);
  };

  componentDidMount() {
    const script = document.createElement('script');

    script.src = 'js/modal.js';
    script.async = true;

    document.body.appendChild(script);
  }

  render() {
    const { signout } = this.state;
    return (
      <>
        <div className='content-wrapper1'>
          <div className='row'></div>
          <div className='modal fade' id='modal-default'>
            <div className='modal-dialog'>
              <div className='modal-content'>
                <div
                  className='modal-header'
                  style={{
                    background: 'rgb(60, 141, 188)',
                    color: '#fff',
                  }}
                >
                  <button
                    type='button'
                    className='close'
                    data-dismiss='modal'
                    aria-label='Close'
                  >
                    <span aria-hidden='true'>×</span>
                  </button>
                  <h4 className='modal-title'>Notifications</h4>
                </div>
                <div className='modal-body'>
                  <p>{this.state.message}</p>
                </div>
                <div className='modal-footer'>
                  {signout ? (
                    <button
                      type='button'
                      className='btn btn-secondary deca-btn-yellow'
                      onClick={this.handleSignout}
                    >
                      Sign out
                    </button>
                  ) : (
                    <button
                      type='button'
                      className='btn btn-secondary deca-btn-orange'
                      onClick={this.state.onClose}
                      data-dismiss='modal'
                    >
                      Ok
                    </button>
                  )}
                  {signout ? (
                    <button
                      type='button'
                      className='btn btn-secondary deca-btn-orange'
                      onClick={this.state.onClose}
                      data-dismiss='modal'
                    >
                      Cancel
                    </button>
                  ) : null}
                </div>
              </div>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
        </div>
      </>
    );
  }
}
const mapDispatchToProps = dispatch =>({
  ...bindActionCreators({setLogOut},dispatch)
})
const mapStateToProps = state =>({
})
export default connect(mapStateToProps, mapDispatchToProps) (MessageBox);
